import { Chat } from "../../entity/Chat";
import { VMessage } from "../../entity/VMessage";
import { toDate } from "../../utils/GlobalFunctions";
import { ChatDto } from "../dto/Chat.Dto";
import { VMessageDto } from "../dto/VMessage.Dto";

export function mapChatDtoToEntity(dto: ChatDto[]): Chat[] {
  return dto
    .map((d) => ({
      id: d.id,
      userId: d.userId,
      storeId: d.storeId,
      title: d.title,
      status: d.status,
      createdAt: d.createdAt ? toDate(d.createdAt) : undefined,
      updatedAt: d.updatedAt ? toDate(d.updatedAt) : undefined,
    }))
    .sort((a, b) => b.createdAt!.getTime() - a.createdAt!.getTime());
}

export function mapMessageDtoToEntity(dto: VMessageDto[]): VMessage[] {
  return dto.map((d) => ({
    id: d.id,
    chatId: d.chatId,
    senderId: d.senderId,
    storeId: d.storeId,
    content: d.content,
    imageUrl: d.imageUrl,
    createdAt: d.createdAt ? toDate(d.createdAt) : new Date(),
    updatedAt: d.updatedAt ? toDate(d.updatedAt) : new Date(),
  }));
}
